module.exports = __webpack_public_path__ + "img/deleted.eb07300e.svg";